import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Subject, forkJoin } from 'rxjs';
import { environment } from 'src/environments/environment';


const BACKEND_URL_DIAMOND = 'https://diamondexchange.in/api/';
const BACKEND_URL_PURPLE = 'https://ad.purplebook9.com/api/';
const BACKEND_URL_FAIRBET = 'https://fairbet1.com/api/';
const BACKEND_URL_DIAMOND9 = 'https://Diamondexch9.site/api/';
const BACKEND_URL_GLOBAL = 'https://global1.in/api/';

const BACKEND_URL_FANCY = environment.apiUrl + '/fancy';
const BACKEND_URL_MATCH = environment.apiUrl + '/match';
const BACKEND_URL_ODDS = environment.apiUrl + '/odds';
const BACKEND_URL_MATCHES = environment.apiUrl + '/matches';

@Injectable({
  providedIn: 'root'
})
export class MatchService {
  private match: any = [];
  private allMatch: any = [];
  private allLiveMatch: any = [];
  private matchActivities: any = [];
  private fancyActivities: any = [];
  private fancy: any = [];
  private diamondFancy: any = [];
  private ownFancyStatus: any = [];
  private autoFancyStatus: any = [];
  private matchUpdated = new Subject<{ match: any[] }>();
  private allMatchUpdated = new Subject<{ allMatch: any[] }>();
  private allLiveMatchUpdated = new Subject<{ allLiveMatch: any[] }>();
  private matchActivitiesUpdated = new Subject<{ matchActivities: any[] }>();
  private fancyActivitiesUpdated = new Subject<{ fancyActivities: any[] }>();
  private fancyUpdated = new Subject<{ fancy: any[] }>();
  private diamondFancyUpdated = new Subject<{ diamondFancy: any[] }>();
  private autoFancyStatusUpdated = new Subject<{ autoFancyStatus: any[] }>();

  // private autoFancyRef: AngularFireObject<any>;
  // private manualFancyRef: AngularFireList<any>;
  constructor(private http: HttpClient) { }

  getAllMatch() { // use
    //return this.http.get('http://128.199.70.62:3000/api/match/getAllActiveMatches');
    return this.http.get(BACKEND_URL_MATCH + '/getAllActiveMatches');
  }

  getMatch(id) { // use
    return this.http.get(BACKEND_URL_MATCH + '/getMatch/' + id);
  }

  getMatches(isActive, isResult, type, sportId = 4) { // use
    let queryParams = `?isActive=${isActive}&isResult=${isResult}&type=${type}&sportId=${sportId}`;
    this.http.get(BACKEND_URL_MATCH + '/getMatches' + queryParams).subscribe((response) => {
      this.match = response['result'];
      //console.log(response['result']);
      this.matchUpdated.next({
        match: [...this.match]
      });
    });
  }

  getUpdateMatchListner() { // use
    return this.matchUpdated.asObservable();
  }

  getAllMatches() {  //use
    this.http.get(BACKEND_URL_MATCH + '/getAllMatches').subscribe((response) => {
      //console.log(response);
      this.allMatch = response['result'];
      //console.log(response['result']);
      this.allMatchUpdated.next({
        allMatch: [...this.allMatch]
      });
    });
  }

  getUpdateAllMatchListner() {  // use
    return this.allMatchUpdated.asObservable();
  }

  getAllLiveMatches() { // use
    this.http.get(BACKEND_URL_MATCH + '/getAllLiveMatches').subscribe((response) => {
      //console.log(response);
      this.allLiveMatch = response['result'];
      //console.log(response['result']);
      this.allLiveMatchUpdated.next({
        allLiveMatch: [...this.allLiveMatch]
      });
    });
  }

  getUpdateAllLiveMatchListner() { // use
    return this.allLiveMatchUpdated.asObservable();
  }

  getMatchActivities(eventId) { // use
    this.http.get(BACKEND_URL_MATCH + '/getMatchesActivities/' + eventId).subscribe((response) => {
      //console.log(response);
      this.matchActivities = response['result'];
      this.matchActivitiesUpdated.next({
        matchActivities: [...this.matchActivities]
      });
    });
  }

  getUpdateMatchActivitiesListner() { // use
    return this.matchActivitiesUpdated.asObservable();
  }

  getFancyActivities(eventId, selectionId) {  // use
    this.http.get(BACKEND_URL_FANCY + '/getFancyActivities/' + eventId + '/' + selectionId).subscribe((response) => {
      //console.log(response);
      this.fancyActivities = response['result'];
      this.fancyActivitiesUpdated.next({
        fancyActivities: [...this.fancyActivities]
      });
    });
  }

  getUpdateFancyActivitiesListner() { // use
    return this.fancyActivitiesUpdated.asObservable();
  }

  // getAutoFancy(id: string) {
  //   this.autoFancyRef = this.db.object('Cricket/' + id);
  //   return this.autoFancyRef;
  // }

  // getManualFancy(id: string) {
  //   this.manualFancyRef = this.db.list('FancyTest/' + id);
  //   return this.manualFancyRef;
  // }

  getDiamondFancy(id, provider) { // use
    const queryParam = `?marketId=${id}&provider=${provider}`;
    this.http.get<{ any }>(BACKEND_URL_FANCY + '/getProviderFancy' + queryParam).subscribe((fancyData) => {
      //console.log(transformedFancyData);
      this.diamondFancy = fancyData;
      this.diamondFancyUpdated.next({
        diamondFancy: { ...this.diamondFancy }
      });
    });
  }

  getUpdateDiamondFancyListner() { // use
    return this.diamondFancyUpdated.asObservable();
  }

  getFancy(id, marketId, provider, status) { // use
    const queryParam = `?marketId=${marketId}&provider=${provider}`;
    let queryParams1;
    if (status == 'All') {
      queryParams1 = `?eventId=${id}&provider=${provider}`;
    }
    else {
      queryParams1 = `?eventId=${id}&status=${status}&provider=${provider}`;
    }

    const res1 = this.http.get<{ any }>(BACKEND_URL_FANCY + '/getProviderFancy' + queryParam);
    const res2 = this.http.get<{ any }>(BACKEND_URL_FANCY + '/getFancyByStatus' + queryParams1);
    forkJoin([res1, res2]).subscribe((transformedFancyData) => {
      //console.log(transformedFancyData);
      this.fancy = transformedFancyData[0];
      this.fancyUpdated.next({
        fancy: { ...this.fancy }
      });

      this.autoFancyStatus = transformedFancyData[1];
      this.autoFancyStatusUpdated.next({
        autoFancyStatus: { ...this.autoFancyStatus }
      });
    });
  }

  getUpdateFancyListner() {  // use
    return this.fancyUpdated.asObservable();
  }

  getAutoUpdateFancyStatusListner() { // use
    return this.autoFancyStatusUpdated.asObservable();
  }

  setFancyStatus(status, eventId, selectionId, name, provider, marketId, runnerId, runners) { // use
    let queryParams;
    let params = JSON.stringify(runners);
    if (status == 'Active') {
      queryParams = `?fancyid=${selectionId}&eventid=${eventId}&provider=${provider}`;
    }
    if (status != 'Active') {
      queryParams = `?id=${selectionId}`;
    }

    const data = {
      status: status, eventId: eventId, selectionId: selectionId,
      name: name, provider: provider, runnerId: runnerId, runners: runners
    };

    let resp = this.http.post(BACKEND_URL_FANCY + '/setFancyStatus', data);
    if (resp) {
      return resp;
    }
  }

  // createMatch(matchData) { // use
  //   const data1 = {
  //     eventId: matchData.event_id, eventName: matchData.event_name,
  //     marketId: matchData.market_id, marketName: 'Match Odds', competitionId: matchData.competition_id,
  //     competitionName: matchData.competition_name, sportId: matchData.sport_id,
  //     sportName: matchData.sport_name, matchRunners: matchData.match_runners, oddsProvider: 'neeraj',
  //     fancyProvider: 'sky', openDate: matchData.open_date, type: 'nitin'
  //   };

  //   const response1 = this.http.post(BACKEND_URL_MATCH + '/createMatch', data1);
  //   return forkJoin([response1]);
  // }

  createMatch(matchData) { // use
    const data1 = {
      eventId: matchData.event_id, eventName: matchData.event_name,
      marketId: matchData.market_id, marketName: 'Match Odds', competitionId: matchData.competition_id,
      competitionName: matchData.competition_name, sportId: matchData.sport_id,
      sportName: matchData.sport_name, matchRunners: matchData.match_runners, oddsProvider: 'neeraj',
      fancyProvider: 'sky', openDate: matchData.open_date, type: 'nitin', markets: matchData.markets,
      marketIds: matchData.market_ids, mType: matchData.mType
    };

    const response1 = this.http.post(BACKEND_URL_MATCH + '/createMatch', data1);
    return forkJoin([response1]);
  }

  getScoreList() {  // use
    const response1 = this.http.get(BACKEND_URL_MATCH + '/getScoreMatchList');
    const response2 = this.http.get(BACKEND_URL_MATCH + '/getCricbuzzScoreMatchList');
    const response3 = this.http.get(BACKEND_URL_MATCH + '/getCricExchScoreMatchList');
    const response4 = this.http.get(BACKEND_URL_MATCH + '/getUpScoreMatchList');
    return forkJoin([response1, response2, response3, response4]);
  }

  updateMatchScore(data1, data2) { // use
    // this.http.post(BACKEND_URL_MATCH + '/updateMatchScore', data)
    // .subscribe((responseData) => {
    //     console.log(responseData);
    // });

    const response1 = this.http.post(BACKEND_URL_MATCH + '/updateMatchScore', data1);
    //const response2 = this.http.put(BACKEND_URL11 + '/updateScore', data2);
    return forkJoin([response1]);
  }

  updateMatchFancy(data) { // use
    // this.http.post(BACKEND_URL_MATCH + '/updateMatchFancy', data)
    // .subscribe((responseData) => {
    //     console.log(responseData);
    // });
    // let provider = data.fancyProvider;
    // if (data.fancyProvider == 'Neeraj') {
    //   provider = data.fancyProvider + ' Fancy';
    // }
    //const data2 = { marketid: data.eventId, fancytype: provider };
    const response1 = this.http.post(BACKEND_URL_MATCH + '/updateMatchFancy', data);
    //const response2 = this.http.put(BACKEND_URL11 + '/updatefancytype', data2);
    return forkJoin([response1]);
  }

  updateMatchOdds(data) {  // use
    //console.log(data);
    //let provider = data.oddsProvider;
    // if (data.oddsProvider == 'Neeraj') {
    //   provider = data.oddsProvider + ' Odds';
    // }
    //return this.http.post(BACKEND_URL_MATCH + '/updateMatchOdds', data);
    const response1 = this.http.post(BACKEND_URL_MATCH + '/updateMatchOdds', data);
    //const response2 = this.http.get(BACKEND_URL11 + '/changeProviderCommon/' + data.eventId + '/' + provider);
    return forkJoin([response1]);
  }

  updateBookMaker(data) {
    return this.http.post(BACKEND_URL_MATCH + '/updateBookMaker', data);
  }

  updateMatchFancyAType(data) { // use
    return this.http.post(BACKEND_URL_MATCH + '/updateMatchFancyAType', data);
  }

  updateMatchAddType(data) { // use
    return this.http.post(BACKEND_URL_MATCH + '/updateMatchAddType', data);
  }

  setResult(input, eventId, selectionId, name) { // use
    const data = { id: selectionId, eventid: eventId, winner: input, name: name };
    const queryParams = `?id=${selectionId}&eventid=${eventId}&winner=${input}`;
    const response1 = this.http.post(BACKEND_URL_FANCY + '/closeFancy', data);
    const response2 = this.http.post(BACKEND_URL_PURPLE + 'setFancyResultThreadCommon' + queryParams, {});
    //const response3 = this.http.post(BACKEND_URL_DIAMOND + 'setFancyResultThreadCommon' + queryParams, {});
    //const response4 = this.http.post(BACKEND_URL_FAIRBET + 'setFancyResultThreadCommon' + queryParams, {});
    //const response5 = this.http.post(BACKEND_URL_DIAMOND9 + 'setFancyResultThreadCommon' + queryParams, {});
    //const response6 = this.http.post(BACKEND_URL_GLOBAL + 'setFancyResultThreadCommon' + queryParams, {});

    return forkJoin([response1, response2]);
  }

  insertAllFancy(data, logs, eventId) {  // use
    const sdata = { data: data, logs: logs, eventId: eventId };
    return this.http.post(BACKEND_URL_FANCY + '/insertAllFancy', sdata);
  }

  updateAllFancy(status, eventId) {  // use
    const data = { status: status, eventId: eventId };
    return this.http.post(BACKEND_URL_FANCY + '/updateAllFancy', data);
  }

  setMatchResult(data) { // use
    let data2 = { resultId: data.selectionid, resultName: data.selectionname, eventId: data.matchid };
    const response1 = this.http.post(BACKEND_URL_MATCH + '/setMatchResult', data2);
    //const response2 = this.http.post(BACKEND_URL11 + '/setMatchResultThreadCommon', data);
    return forkJoin([response1]);
  }

  setResultStatus(data) { // use
    return this.http.put(BACKEND_URL_MATCH + '/setResultStatus/' + data, {});
  }

  deleteMatch(data) { // use
    return this.http.get(BACKEND_URL_MATCH + '/deleteMatch?eventId=' + data);
  }

  matchRollBack(data) {  // use
    return this.http.put(BACKEND_URL_MATCH + '/matchRollBack/' + data, {});
  }

  setProviders(oddsProvider, fancyProvider) { // use
    let data = { oddsProvider: oddsProvider, fancyProvider: fancyProvider };
    return this.http.post(BACKEND_URL_MATCH + '/setProviders', data);
  }

  getProviders() { // use
    return this.http.get(BACKEND_URL_MATCH + '/getProviders');
  }

  setEventId(eventId, mEventId) { // use
    let data = { mEventId: mEventId };
    return this.http.put(BACKEND_URL_MATCH + '/setEventId/' + eventId, data);
  }

  getAllDMatches() {  // use
    const res1 = this.http.get(BACKEND_URL_MATCH + '/getAllMatches');
    const res2 = this.http.get(BACKEND_URL_MATCHES + '/getAllDMatches');
    return forkJoin([res1, res2]);
  }

  // createDMatch(matchData) {  // use
  //   const data1 = {
  //     eventId: matchData.eventId, eventName: matchData.eventName, marketId: matchData.marketId,
  //     marketName: 'Match Odds', competitionId: matchData.competitionId, competitionName: matchData.competitionName, sportId: matchData.sportId,
  //     sportName: matchData.sportName, matchRunners: matchData.matchRunners, openDate: matchData.openDate,
  //     type: 'auto'
  //   };

  //   const response1 = this.http.post(BACKEND_URL_MATCH + '/createMatch', data1);
  //   return forkJoin([response1]);
  // }

  createDMatch(matchData) {  // use
    const data1 = {
      eventId: matchData.event_id, eventName: matchData.event_name, marketId: matchData.market_id,
      marketName: 'Match Odds', competitionId: matchData.competition_id, competitionName: matchData.competition_name, sportId: matchData.sport_id,
      sportName: matchData.sport_name, matchRunners: matchData.match_runners, openDate: matchData.open_date,
      type: 'auto', mType: matchData.mType, marketIds: matchData.market_ids, markets: matchData.markets
    };

    const response1 = this.http.post(BACKEND_URL_MATCH + '/createMatch', data1);
    return forkJoin([response1]);
  }

  addManualMatch(matchData) {
    const matchRunners = [matchData.runner1, matchData.runner2, matchData.runner3];
    const data = {
      eventId: matchData.eventId, eventName: matchData.eventName, marketId: matchData.marketId,
      marketName: 'Match Odds', competitionId: '999999', competitionName: 'T10', sportId: 4,
      sportName: 'Cricket', matchRunners, openDate: matchData.openDate,
      type: 't10', matchType: matchData.matchType
    };

    return this.http.post(BACKEND_URL_MATCH + '/addManualMatch', data);
  }

  setchno(body) {
    return this.http.post(BACKEND_URL_MATCH + '/setChanel', body);
  }

  updateHeader(data) { // use
    const response1 = this.http.post(BACKEND_URL_PURPLE + 'updateBookMakerHeader', data);
    //const response2 = this.http.post(BACKEND_URL_DIAMOND + 'updateBookMakerHeader', data);
    //const response3 = this.http.post(BACKEND_URL_FAIRBET + 'updateBookMakerHeader', data);
    //const response4 = this.http.post(BACKEND_URL_DIAMOND9 + 'updateBookMakerHeader', data);
    //const response5 = this.http.post(BACKEND_URL_GLOBAL + 'updateBookMakerHeader', data);

    return forkJoin([response1]);
  }

  setMessage(data) { // use
    const response1 = this.http.post(BACKEND_URL_PURPLE + 'setCommonMessage', data);
    //const response2 = this.http.post(BACKEND_URL_DIAMOND + 'setCommonMessage', data);
    //const response3 = this.http.post(BACKEND_URL_FAIRBET + 'setCommonMessage', data);
    //const response4 = this.http.post(BACKEND_URL_DIAMOND9 + 'setCommonMessage', data);
    //const response5 = this.http.post(BACKEND_URL_GLOBAL + 'setCommonMessage', data);

    return forkJoin([response1]);
  }

  setLimit(marketid, formData) { // use
    const { sites, oddsMin, oddsMax, oddsProfitLoss, bookMin, bookMax, bookProfitLoss, fancyMin, fancyMax, fancyProfitLoss } = formData;
    const data = { marketid, oddsMin, oddsMax, oddsProfitLoss, bookMin, bookMax, bookProfitLoss, fancyMin, fancyMax, fancyProfitLoss };
    if (sites == 'all') {
      const response1 = this.http.post(BACKEND_URL_PURPLE + 'setCentralMinMaxBet', data);
      //const response2 = this.http.post(BACKEND_URL_DIAMOND + 'setCentralMinMaxBet', data);
      //const response3 = this.http.post(BACKEND_URL_FAIRBET + 'setCentralMinMaxBet', data);
      //const response4 = this.http.post(BACKEND_URL_DIAMOND9 + 'setCentralMinMaxBet', data);
      //const response5 = this.http.post(BACKEND_URL_GLOBAL + 'setCentralMinMaxBet', data);

      return forkJoin([response1]);
    }
    else {
      return this.http.post(formData.sites + '/api/setCentralMinMaxBet', data);
    }
  }

  setResultRollback(eventId, selectionId) { // use
    const data = { id: selectionId, eventId };
    const data1 = `?fancyid=${selectionId}`;
    const response1 = this.http.post(BACKEND_URL_FANCY + '/rollbackFancy', data);
    const response2 = this.http.post(BACKEND_URL_PURPLE + 'rollbackCommonFancyResult' + data1, {});
    //const response3 = this.http.post(BACKEND_URL_DIAMOND + 'rollbackCommonFancyResult' + data1, {});
    //const response4 = this.http.post(BACKEND_URL_FAIRBET + 'rollbackCommonFancyResult' + data1, {});
    //const response5 = this.http.post(BACKEND_URL_DIAMOND9 + 'rollbackCommonFancyResult' + data1, {});
    //const response6 = this.http.post(BACKEND_URL_GLOBAL + 'rollbackCommonFancyResult' + data1, {});

    return forkJoin([response1, response2]);
  }
}